import React from "react";
import Header from "../components/Header";

import { useRef , useState} from "react";
import '../../src/components/styles/Home.css';
import "../../src/components/styles/About.css";
import basuru_img from "../assets/CTA/Basuri2 1.jpg";
import Footer from "../components/Footer";
import slidcard from "../assets/slidcard.jpeg";
import slidcard2 from "../assets/slidcard2.jpeg";
import about_img from "../assets/About_img/About Us_- Banner.jpg"
import aboutezpujapath from "../assets/About_img/aboutezpujapath.png";
import About_img_2 from "../assets/banner About Us-01 1.jpg"


import { toast, ToastContainer } from "react-toastify";
import BookPanditForm from "../components/BookPanditForm";
import { getPandits } from "../services/panditService";
import { useEffect } from "react";



function About() {

    const [isMobile, setIsMobile] = useState(false);
  const scrollRef = useRef(null);
  const scroll = (direction) => {
    if (scrollRef.current) {
      const { scrollLeft, clientWidth } = scrollRef.current;
      const scrollAmount = clientWidth / 2; // Adjust scroll speed
      scrollRef.current.scrollTo({
        left: direction === "left" ? scrollLeft - scrollAmount : scrollLeft + scrollAmount,
        behavior: "smooth"
      });
    }
  };
  const testimonials = [
    {
      id: 1,
      name: "“An amazing service”",
      image: require("../assets/pandits.png"), // ✅ Fixed
      description: "Lorem ipsum dolor sit ametolil col consectetur adipiscing lectus a nunc mauris scelerisque sed egestas.",
      position: "CEO, Carryminati production house",
      quote: "Ajay Nagar",
    },
    {
      id: 2,
      name: "“One of a kind service”",
      image: require("../assets/pandits.png"), // ✅ Fixed
      description: "Ultrices eros in cursus turpis massa tincidunt sem nulla pharetra diam sit amet nisl suscipit adipis.",
      position: "Developer, THYO India",
      quote: "Deepak Gupta",
    },
    {
      id: 3,
      name: "“The best service”",
      image: require("../assets/pandits.png"), // ✅ Fixed
      description: "Convallis posuere morbi leo urna molestie at elementum eu facilisis sapien pellentesque habitant.",
      position: "CEO, Carryminati production house",
      quote: "Rajiv Ranjan",
    }

  ];


  const [panditllist, setPanditllist] = useState([]);
const panditScrollRef = useRef(null);



useEffect(() => {

  const selectedCityId =
    localStorage.getItem("selectedCityId") || "";

  getPandits(selectedCityId)
    .then((response) => {

      const panditList =
        response?.data?.data?.pandit_list || [];

      setPanditllist(panditList);

      console.log(
        "Pandit List:",
        panditList
      );

    })
    .catch((err) => {

      console.error(
        "Pandit API Error:",
        err
      );

    });

}, []);


  

  return (

    
    <>
      <Header />
      <div className="About_banner mt-4 mt-md-5">
      <img src={About_img_2} alt="" className=" img-fluid w-100 d-block d-md-none" />

        <img src={about_img} alt="" className=" img-fluid w-100 d-none d-md-block" />
      </div>
      <div className="container p-3">
        <div className="row align-items-center">
          <div className="col-sm-4  text-center text-sm-start mb-4 mb-sm-0">
            <img src={aboutezpujapath} alt="Puja Type" className="mx-auto mb-3 d-none d-md-block" style={{ objectFit: 'contain', width: '100%', height: 'auto' }} />
          </div>
          <div className="col-sm-8">
            <p className="headercolor">About Ez Puja Path</p>
            <p className="ptextcolor">At Ez Puja Path, we are dedicated to bringing the divine essence of Vedic rituals
              and astrology to your doorstep. Rooted in the ancient wisdom of the Vedas
              and Jyotish Shastra, our services connect you with the spiritual traditions that guide life’s journey.
              We believe that Puja and astrology are not just rituals but a pathway to aligning your life with cosmic energy.
              Whether it’s performing sacred Pujas, seeking astrological guidance, or understanding karmic influences, our
              expert Pandits help you navigate life’s challenges with divine blessings.
            </p>
            <div>
              <p className="ptextcolor1"> 🔹<span className="ptextcolor2" >Authentic Vedic Rituals </span>  – Performed by experienced Pandits to bring peace, prosperity, and positivity </p><br />
              <p className="ptextcolor1">🔹<span className="ptextcolor2">Personalized Astrological Guidance </span> – Insights to align your life with cosmic order </p> <br />
              <p className="ptextcolor1">🔹<span className="ptextcolor2">Seamless Puja Booking </span>  – Online & offline services across India for your spiritual needs </p>
              
              <p className="ptextcolor mt-4 d-none d-md-block" >
                At Ez Puja Path, we make spirituality accessible, ensuring that every ritual
                is performed with devotion and authenticity.
                Experience divine grace and transform your life with our trusted services!
              </p>
            </div>
            
          </div>
          
        </div>
        
      </div>


      <p className="ptextcolor mt-4 d-block d-md-none container text-white pt-2 pb-2" style={{backgroundColor:"#6B2A00"}}>
                At Ez Puja Path, we make spirituality accessible, ensuring that every ritual
                is performed with devotion and authenticity.
                Experience divine grace and transform your life with our trusted services!
              </p>



      {/* OUR ASTROLOGERS SECTION */}
      <section className="position-relative text-white py-1 d-flex align-items-center  "   style={{ backgroundColor: "#FFFAE8" }}  >
        <div className="container p-3 ">
          <div className="text-center mb-4 py-1">
            <span className="botoun33 d-block p-2 ">Our Astrologers</span>
            <h2 className="displaa ">
              Our astrologers are like guides pointing <br className="d-none d-md-block" />
              the way to understanding the universe.
            </h2>.0
          </div>

    <div className="container py-4 position-relative">
      <button
        className="btn priimary position-absolute start-0 top-50 translate-middle-y d-none d-md-block"
        onClick={() => panditScrollRef.current?.scrollBy({ left: -300, behavior: 'smooth' })}
        style={{
          zIndex: 10,
          backgroundColor: '#6B2A00',
          color: 'white',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          padding: 0
        }}
      >
        ❮
      </button>

      <div
        ref={panditScrollRef}
        className="d-flex overflow-auto"
        style={{
          scrollBehavior: "smooth",
          scrollbarWidth: "none",
          gap: "20px",
          paddingLeft: "10px",
          paddingRight: "10px"
        }}
      >
        {panditllist.map((pandit, index) => (
          <div 
            key={index} 
            className="card_container2"
            style={{
              flex: "0 0 calc(25% - 15px)",
              minWidth: "280px",
              maxWidth: "300px"
            }}
          >
            <img
              src={pandit.photo}
              alt={pandit.name}
              className="rounded mx-auto d-block"
              style={{ 
                height: '250px', 
                objectFit: 'cover', 
                width: '100%',
                borderRadius: '10px'
              }}
            />
            {/* <h3 className="ms-auto mt-3">Chat Now</h3> */}
            <div style={{ margin: "12px", textAlign: "justify" }}>
              <h1 style={{ fontSize: '18px', fontWeight: '600', color: '#6B2A00' }}>
                {pandit.name}
              </h1>
              <p style={{ fontSize: '13px', color: '#555', marginBottom: '10px' }}>
                {pandit.description.substring(0, 100)}...
              </p>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2 style={{ fontSize: '16px', marginBottom: 0 }}>
                  ⭐ {pandit.experience} Yrs
                </h2>
                <p style={{ fontSize: '14px', color: '#E3952A', marginBottom: 0 }}>
                  ₹{pandit.dakshina}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <button
        className="btn priimary position-absolute end-0 top-50 translate-middle-y d-none d-md-block"
        onClick={() => panditScrollRef.current?.scrollBy({ left: 300, behavior: 'smooth' })}
        style={{
          zIndex: 10,
          backgroundColor: '#6B2A00',
          color: 'white',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          padding: 0
        }}
      >
        ❯
      </button>
    </div>

    {panditllist.length === 0 && (
      <div className="text-center">
        <p>No pandits available for your city</p>
      </div>
    )}


  </div>
</section>






      <section className="py-5 bg-light">
        <div className="container">
          {/* Section Header */}
          <div className="text-center mb-4">
            <span className="text-uppercase testinaction">Testimonials</span>
            <h2 className="fboldtext">What our clients say</h2>
          </div>
          {/* Bootstrap Grid - 2 Rows, 3 Columns Each */}
          <div className="row g-4">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="col-md-4 ">
                <div className="card border-1 shadow-sm p-5 rounded-4">
                  <div className="">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="rounded-circle me-3"
                      width="60"
                      height="60"
                      style={{ objectFit: "cover", border: '1px solid black' }}
                    />
                    <h5 className="textiname mb-3 mt-3">{testimonial.name}</h5>
                    <p className="psmaltext small mb-2">{testimonial.description}</p>
                  </div>
                  <blockquote className="mt-3 textinaeme">
                    {testimonial.quote}
                  </blockquote>
                  <p className="psmaltext small mb-0">{testimonial.position}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>



            <div className={isMobile ? "bg-white" : "Container_img img-fluid"}>
    
    
            <BookPanditForm />
            <ToastContainer />
    
            </div>


      <Footer />
    </>
  );
}

export default About;
